// extracted by mini-css-extract-plugin
export default {"container-input":"input-color_container-input__UYRnd","inline":"input-color_inline__ZVRdW","rotate":"input-color_rotate__8VjgU"};